// extracted by mini-css-extract-plugin
export default {"overlay":"globalModal_overlay__md3sX","modalContent":"globalModal_modalContent__mndSC"};